import { Model } from '@vuex-orm/core'
import ItemModel from '@/models/ItemModel'
import CartModel from '@/models/CartModel'
import LineItemModel from '@/models/LineItemModel'

import _get from 'lodash/get'
import _pick from 'lodash/pick'

export default class CartItemModel extends Model {
  static entity = 'cartItems'

  static nameSingular = 'Cart Item'
  static namePlural = 'Cart Items'

  static fields() {
    return {
      id: this.uid(),
      quantity: this.number(0),
      item_id: this.attr(null),
      item: this.belongsTo(ItemModel, 'item_id'),
      cart_id: this.attr(null),
      cart: this.belongsTo(CartModel, 'cart_id'),
      type: this.string(LineItemModel.lineItemTypes.PRODUCT),
      oversold: this.boolean(0),
      is_custom: this.boolean(0),
      custom_name: this.string().nullable(),
      custom_price: this.number(0),
    }
  }

  get data_for_order() {
    return {
      ..._pick(this, ['item_id', 'quantity']),
      type: this.type.toUpperCase(),
      item_name: this.name,
      item_price: this.price || 0,
      item_unit: _get(this.item, 'unit', ''),
      item_date: _get(this.item, 'date', ''),
    }
  }

  get remaining_stock() {
    return _get(this.item, 'stock', Infinity) - this.quantity
  }

  /**
   * Get item name
   */
  get name() {
    return this.is_custom && this.custom_name
      ? this.custom_name
      : _get(this.item, 'name', '')
  }

  /**
   * Get item price
   */
  get price() {
    return this.is_custom ? this.custom_price : _get(this.item, 'price', 0)
  }

  /**
   * Get price adjusted in USD (cents x 100)
   */
  get price_usd() {
    return this.price / 100
  }

  /**
   * Get priced formatted like a -$D,DDD.CC
   */
  get price_formatted() {
    const prefix = this.price_usd < 0 ? '-$' : '$'
    return `${prefix}${Math.abs(this.price_usd).toFixed(2)}`
  }

  /**
   * Get price times quantity
   */
  get subtotal() {
    return this.price * this.quantity
  }
}
